<template>
  <b-modal
    id="modal-save-person-ipt-required"
    style="width: min-content"
    hide-footer
    centered
    :noCloseOnBackdrop="isBusy"
    :noCloseOnEsc="isBusy"
    :hideHeaderClose="isBusy"
    size="lg"
  >
    <div class="content-header-modal-person">
      <h1>
        ¿Deseas guardar las siguientes personas para realizarles inspección de
        puesto de trabajo?
      </h1>
    </div>
    <div class="content-body-modal-person mt-5 mb-5">
      <b-table
        :items="selected"
        :fields="fields"
        class="table-person-ipt-required"
      >
        <template #cell(name)="row">
          {{ row.item.name }}<br />
          <b>c.c. {{ row.item.cc }}</b>
        </template>
      </b-table>
    </div>
    <div class="d-flex justify-content-center">
      <button class="button-save-employee" @click.prevent="saveSelected" :disabled="isBusy">
        <span class="mr-2">
          Guardar
          <img class="pl-1 mb-1 mr-1" src="@/assets/images/icons/save-white.svg" />
        </span>
        <b-spinner v-if="isBusy" />
      </button>
    </div>
    <div class="mt-4" v-if="errors.length > 0">
      <b-alert
        dismissible
        v-for="(error, index) in errors"
        :key="index"
        show
        variant="danger"
      >
        {{ error }}
      </b-alert>
    </div>
  </b-modal>
</template>

<script>
import { saveEmployeesIpt } from "@/services/health-tracker/ges/service";
export default {
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        {
          key: "charge",
          label: "Cargo",
        },
        {
          key: "name",
          label: "Nombre / C.C",
        },
        {
          key: "area",
          label: "Área",
        },
        {
          key: "health_condition",
          label: "Condición de salud",
        },
      ],
      id: this.$route.params.id,
      errors: [],
      isBusy: false,
    };
  },
  methods: {
    async saveSelected() {
      const me = this;
      
      let formData = {
        ges_id: me.id,
        employees: me.selected.map((x) => x.employee_id),
      };

      try {
        me.isBusy = true;
        me.errors = [];
        await saveEmployeesIpt(formData);
        me.$emit("savePersonIpt");
        me.$bvModal.hide("modal-save-person-ipt-required");
        me.$bvModal.show("modal-success");
      } catch (error) {
        if (error?.response) {
          if (error?.response?.data) {
            const { data } = error?.response;
            if (data?.message) {
              if (data?.message?.employees)
                me.errors.push(data?.message?.employees[0]);
            }
          }
        } else {
          me.$bvToast.toast("Error en el servidor, vuelve a intentarlo", {
            title: "Error al guardar empleados",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger",
            solid: true,
          });
        }
      } finally {
        me.isBusy = false;
      }
    },
  },
};
</script>

<style lang="css">
.content-header-modal-person {
  text-align: center;
}
.content-header-modal-person h1 {
  font-family: Ubuntu;
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 24px;
  text-align: center;
  color: #455a64;
  text-transform: none !important;
}

.table-person-ipt-required {
  box-shadow: 0 0 4px 2px transparent !important;
  border-radius: 0 !important;
}
.button-save-employee {
  background: #5d5fef;
  border: 1px solid #5d5fef;
  border-radius: 8px;
  padding: 5px 10px;
  color: white;
  display: flex;
  align-items: center;
}
</style>
